import { BrowserModule } from '@angular/platform-browser';
import { AnimatorModule } from 'css-animator';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { RebusApp } from './app.component';
import { ENV } from '@app/env';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NgrxModule } from '../ngrx/ngrx.module';
import { PipesModule } from '../pipes/pipes.module';
import { PROVIDERS } from '../providers';
import '../shared/imports/rxjs.import';
import { JsonpModule, HttpModule } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { QuestionCommentsModal } from '../pages/question/question-comments/question-comments.modal';
import { AgmCoreModule } from '@agm/core';
import { NoteDetailModal } from '../pages/notes/note-detail/note-detail.modal';
import { ComponentsModule } from '../components/components.module';
import { PollActiveComponent } from '../pages/poll/components/poll-active/poll-active';
import { PollComponentsModule } from '../pages/poll/components/poll-components.module';
import { EventPollActiveComponent } from '../pages/poll-event/components/event-poll-active/event-poll-active';
import { PollEventComponentsModule } from '../pages/poll-event/components/poll-events-components.module';
import { VotingActiveComponent } from '../pages/voting/components/voting-active/voting-active';
import { VotingComponentsModule } from '../pages/voting/components/voting-component.module';
import { IonicImageViewerModule } from 'ionic-img-viewer';
import { SocialLoginModule, AuthServiceConfig, GoogleLoginProvider, FacebookLoginProvider } from "angular5-social-login";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxTwitterTimelineModule } from 'ngx-twitter-timeline';

export const FIREBASE_CONFIG = {
  apiKey: ENV.firebase.apiKey,
  authDomain: ENV.firebase.authDomain,
  databaseURL: ENV.firebase.databaseURL,
  projectId: ENV.firebase.projectId,
  storageBucket: ENV.firebase.storageBucket,
  messagingSenderId: ENV.firebase.messagingSenderId
};

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function getAuthServiceConfigs() {
  if (ENV.mode === 'Development') {
    const config = new AuthServiceConfig([
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider(ENV.facebook_client_id)
      }
    ]);
    return config;
  } else {
    const config = new AuthServiceConfig([
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider(ENV.facebook_client_id)
      }, {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(ENV.google_client_id)
      }
    ]);
    return config;
  }
}

@NgModule({
  declarations: [
    RebusApp,
    QuestionCommentsModal,
    NoteDetailModal,
    PollActiveComponent,
    EventPollActiveComponent,
    VotingActiveComponent
  ],
  imports: [
    BrowserAnimationsModule,
    SocialLoginModule,
    ComponentsModule,
    NgrxModule,
    PipesModule,
    JsonpModule,
    AnimatorModule,
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    AngularFireStorageModule,
    // Esto presenta problemas cuando se abren varias pestañas en un mismo navegador, se deja sin soporte offline
    // AngularFirestoreModule.enablePersistence(),
    AngularFirestoreModule,
    AngularFireAuthModule,
    IonicImageViewerModule,
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    NgxTwitterTimelineModule.forRoot(),
    HttpClientModule,
    HttpModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    AgmCoreModule.forRoot({
      apiKey: ENV.google_api
    }),
    (ENV.mode !== 'Production') ? StoreDevtoolsModule.instrument({ maxAge: 25 }) : [],
    BrowserModule,
    IonicModule.forRoot(RebusApp, {
      mode: 'md',
      monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    }),
    PollComponentsModule,
    PollEventComponentsModule,
    VotingComponentsModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    RebusApp,
    QuestionCommentsModal,
    NoteDetailModal,
    PollActiveComponent,
    EventPollActiveComponent,
    VotingActiveComponent
  ],
  providers: [
    ...PROVIDERS,
    {
      provide: AuthServiceConfig,
      useFactory: getAuthServiceConfigs
    },
    { provide: ErrorHandler, useClass: IonicErrorHandler }
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts